<template>
  <about-us-header />
  <about-back />
  <about-buttons />
  <div class="license">
    <div class="container">
      <p
        v-if="title"
        class="license-title"
        v-html="title"
      />
      <p
        v-if="description"
        class="license-sub"
        v-html="description"
      />
      <div
        v-if="licenses"
        class="license-box"
      >
        <div
          v-for="lic in licenses"
          :key="lic"
          class="license-box__item"
        >
          <a
            v-if="lic.doc"
            :href="cdn + lic.doc"
          ><img
             class="download-img"
             src="../assets/images/download.svg"
             alt=""
           >
            <p
              v-if="lic.ru"
              v-html="lic.ru"
            />
          </a>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import aboutUsHeader from "./aboutUsHeader.vue";
import AboutBack from "./AboutBack.vue";
import aboutButtons from "./aboutButtons.vue";
import axios from "axios";
export default {
  components: { aboutUsHeader, AboutBack, aboutButtons },
  data() {
    return {
      licenses: null,
      title: null,
      description: null,
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  mounted() {
    this.getLicense();
  },
  methods: {
    getLicense() {
      axios
        .get("V1/licenses")
        .then((response) => {
          this.title = response.data.data.title;
          this.description = response.data.data.description;
          //   this.licenses = response.data.data;
          this.licenses = response.data.data.downloads;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 768px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 768px) and (max-width: 1024px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1024px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1620px) and (max-width: 2560px) {
    @content;
  }
}
.license {
  background: #efefef;
  padding: 85px 0;
  &-title {
    @include fontStyle(Roboto, normal, 500, 28px, 34px, #373737);
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  &-sub {
    @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    padding: 30px 0;
  }
  &-box {
    background: #ffffff;
    &__item {
      a {
        display: flex;
        align-items: center;
      }
      img {
        width: 60px;
        height: 40px;
        padding-left: 20px;
      }
      p {
        padding: 23px 0 0px 20px;
        @include fontStyle(Roboto, normal, 300, 20px, 24px, #373737);
      }
      &:first-child {
        p {
          // padding-top: 35px;
        }
      }
    }
  }
  @include mobile() {
    padding: 0px 0 20px 0;
    &-title {
      display: none;
    }
    &-sub {
      font-size: 14px;
      line-height: 16px;
      padding: 10px 0;
      margin-bottom: 0 !important;
    }
    &-box {
      background: transparent;
      hr {
        display: none;
      }
      &__item {
        a {
          // height: 20px;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 2px;
          margin-bottom: 3px;
          padding-left: 0;
        }
        p {
          font-size: 14px;
          line-height: 16px;
          padding: 0px;
          padding-top: 13px;
          padding-left: 4px;
        }
        &:first-child {
          p {
            padding-top: 15px;
          }
        }
      }
    }
  }
  @include tablet() {
    padding: 0px 0 30px 0;
    &-title {
      display: none;
    }
    &-sub {
      font-size: 14px;
      line-height: 16px;
      padding: 10px 0;
    }
    &-box {
      background: transparent;
      hr {
        display: none;
      }
      &__item {
        a {
          height: 15px;
        }
        img {
          width: 18px;
          height: 18px;
          margin-right: 2px;
          margin-bottom: 19px;
          padding-left: 0;
        }
        p {
          font-size: 14px;
          line-height: 16px;
          padding: 0px;
          padding-left: 4px;
          padding-top: 0px;
        }
        &:first-child {
          p {
            padding-top: 0px;
          }
        }
      }
    }
  }
  @include tablet-1024() {
    padding: 25px 0;
    &-title {
      font-size: 17px;
      line-height: 20px;
    }
    &-sub {
      font-size: 13px;
      line-height: 16px;
      padding: 10px 0;
    }
    &-box {
      background: transparent;
      hr {
        display: none;
      }
      &__item {
        a {
          height: 20px;
        }
        img {
          width: 36px;
          height: 15px;
          margin-right: 5px;
          margin-bottom: 18px;
        }
        p {
          font-size: 13px;
          line-height: 17px;
          padding: 0px;
          padding-top: 0px;
        }
        &:first-child {
          p {
            padding-top: 0px;
          }
        }
      }
    }
  }
}
</style>
